import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';
const LogoutContainer = styled.div`
  position: fixed;
  top: ${422 * Screen.widthRatio}px;
  left: ${260 * Screen.widthRatio}px;
  width: ${1000 * Screen.widthRatio}px;
`;

export default withAnimation(LogoutContainer);
